import React from 'react';
import { houseModes } from '../../data/houseModes';
import type { HouseMode } from '../../types/anna';
export function HouseModeChip({
  mode,
  active = false,
  size = 'sm'
}: {
  mode: HouseMode;
  active?: boolean;
  size?: 'sm' | 'wall';
}) {
  const spec = houseModes.find(m => m.id === mode);
  const Icon = spec?.icon;
  const sizeClass = size === 'wall' ? 'gap-2.5 px-4 py-1.5 text-[22px]' : 'gap-2 px-3 py-1.5 text-[13px]';
  return <span className={`inline-flex items-center whitespace-nowrap rounded-full border font-medium ${sizeClass} ${active ? 'border-accent/50 bg-accent/10 text-ink' : 'border-white/10 bg-white/[0.03] text-ink-muted'}`} data-id="element-1153" data-mp="2hgt0dhilvf8d">
      {Icon && <Icon className={`${size === 'wall' ? 'h-5 w-5' : 'h-3.5 w-3.5'} ${active ? 'text-accent' : ''}`} strokeWidth={1.75} aria-hidden data-id="element-1154" data-mp="23qphn0ixq3no" />}
      {mode}
    </span>;
}